/** @format */
export function getAvatar(id) {
  return this.getField(id, "photoURL");
}
